import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/pookieApi";

const DEVICE_KEY = "pl_device_id";
const EMAIL_KEY = "pl_pro_email";

export function getDeviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (crypto?.randomUUID && crypto.randomUUID()) || `dev_${Math.random().toString(36).slice(2)}${Date.now()}`;
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

export function getProEmail() {
  return localStorage.getItem(EMAIL_KEY) || null;
}

export function setProEmail(email) {
  if (email) localStorage.setItem(EMAIL_KEY, email);
  else localStorage.removeItem(EMAIL_KEY);
}

export function useSubscription() {
  const [status, setStatus] = useState({
    is_pro: false,
    plan_id: null,
    expires_at: null,
    free_used: 0,
    free_quota: 2,
    free_remaining: 2,
    loading: true,
  });

  const refresh = useCallback(async () => {
    const device_id = getDeviceId();
    const email = getProEmail();
    try {
      const { data } = await api.get("/subscription/status", {
        params: { device_id, ...(email ? { email } : {}) },
      });
      setStatus({ ...data, loading: false });
    } catch (e) {
      setStatus((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...status, refresh };
}
